module.exports = __webpack_public_path__ + "img/tw-bus2.b021ac49.png";